(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('MaturityDetailReportController', MaturityDetailReportController);

	MaturityDetailReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$location', '$anchorScroll'];

	function MaturityDetailReportController($window, WineRepository, $log, lodash, $state, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.jumpTo = jumpTo;

		self.print = print;

		self.toggle = toggle;

		self.title = $state.current.data.title;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles',
							'Average&nbsp;Cost',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						var winesByMaturity = lodash.groupBy(self.wines, function(w) {
							return w.getMaturity();
						});

						var maturitiesOrder = [
							'Early',
							'Young',
							'Mature',
							'Old',
							'Late',
							'Uncertain'
						];

						var winesGroupedOrdered = {};

						// order by maturitiesOrder
						lodash.forEach(maturitiesOrder, function(maturityName) {
							winesGroupedOrdered[maturityName] = winesByMaturity[maturityName];
						});

						// initialize totals
						var grandTotals = {
							bottles: totalBottles,
							value: 0,
							maturities: Object.keys(winesByMaturity).length,
							wines:  totalWines
						};

						lodash.forEach(winesGroupedOrdered, function(wines, maturity) {
							// count bottles for grouping, start at 0
							var totalMaturityBottles = lodash.reduce(wines, function(total, wine) {
								return total + wine.cellar.qty;
							}, 0);

							// total value for grouping
							var totalMaturityValue = lodash.sum(wines, function(wine) {
								var value = (wine.cellar && wine.cellar.value) ? parseFloat(wine.cellar.value) : 0;
								return (value > 0) ? value * wine.cellar.qty : 0;
							});
							// update grand total value
							grandTotals.value += totalMaturityValue;

							var formattedWines = [];

							lodash.forEach(wines, function(wine) {
								var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
								var category = (wine.category && wine.category.name) ? wine.category.name : '';
								var type = varietal + category;

								var avgPurchasePrice = wine.avgPurchasePrice();
								var avgPurchasePriceFloat = $window.numeral(avgPurchasePrice);

								var valueGainFormatted = wine.getRelativeGainPercentFormatted(avgPurchasePriceFloat);
								var valueGainClass = wine.getValueGainClass(avgPurchasePriceFloat);

								// data we want to display on a single wine
								formattedWines.push({
									name: wine.getFullName(),
									appelation: wine.getFullAppellation(),
									type: type,
									size: wine.bottleSize.name,
									qty: wine.cellar.qty,
									avgPurchasePrice: avgPurchasePrice,
									value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
									gain: valueGainFormatted,
									gainClass: valueGainClass
								});
							});

							self.report.groups.push({
								groupName: maturity,
								bottles: totalMaturityBottles,
								value: $window.numeral(totalMaturityValue).format('$0,0[.]00'),
								wines: formattedWines,
								visible: true
							});

						});

						self.report.totals = [
							// 'Maturity / Wine',
							'Total maturities: ' + grandTotals.maturities + '<br/>Total wines: ' + grandTotals.wines,
							// 'Size',
							null,
							// 'Bottles',
							grandTotals.bottles,
							// 'Average Cost',
							null,
							// 'Value',
							$window.numeral(grandTotals.value).format('$0,0[.]00'),
							// 'Gain / Loss'
							null
						];

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function jumpTo(id) {
			$location.hash(id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}

		function toggle($index) {
			self.report.groups[$index].visible = ! self.report.groups[$index].visible;
		}
	}

})();
